import React from 'react';
import {Box, Button} from '@material-ui/core';
import {MetaTags} from 'react-meta-tags';
import axios from 'axios';
import Cookies from 'js-cookie';
import LinearProgress from '@mui/material/LinearProgress';
import Authorization from '../components/Authorization';
import Alert from '../components/Alert';
import RadioButtonCheckedIcon from '@mui/icons-material/RadioButtonChecked';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import VisibilitySave from './VisibilitySave';
import { useSelector } from 'react-redux';
import {API_URL} from '../utils/EnvVars';
import Header from "../common/HeaderMy";
import '../styles/bizofficer-a.css';
import 'font-awesome/css/font-awesome.min.css';

  
  export default function Execute() {
	const userObj = useSelector(state => state.userDetails);	
	const isloggedin = Cookies.get('isrwadminloggedin');
	const childRefAlert = React.useRef();
	const childRefSave = React.useRef(); 
	const childRefAuthorization = React.useRef();
	const [privileges, setPrivileges] = React.useState("");
	const [dataLoading, setDataLoading] = React.useState(true);
	
	const [row, setRow] = React.useState({});

	const [severityAlert, setSeverityAlert] = React.useState("error");
	const [alertMessage, setAlertMessage] = React.useState("");

	
	// check if logged in
	React.useEffect(() => {
		if(!isloggedin){
			window.location.href='login';
		}
	}, [isloggedin]);

	React.useEffect(() => {		
		if(userObj && userObj.registerId>0){			
			getApiData();
		}
	}, [userObj]);

	async function getApiData(){ 
		  let apiUrl=API_URL+'/crm-modules-visibility';
		  let axiosHeader = {
					'Content-Type': 'multipart/mixed',
					'device': 'web',
					'registerId': userObj.registerId,
					'uid': userObj.loginId,
					'fullName': userObj.fullName,
					'token': userObj.token,
			};
			const config = {
				method: 'get',
				url: apiUrl,
				headers: axiosHeader
			}
			await axios(config)
			   .then(response => {
				setDataLoading(false);
				if(response  && response.status===200 && response.data && response.data.responseTxt==="success"){  
					///document.write(JSON.stringify(response.data.obj));
					setRow(response.data.obj);	
					setPrivileges(response.data.privileges);					
				}else if(response && response.data && response.data.responseTxt==="invalidtoken"){
					window.location.href='invalidtoken';
				}else if(response && response.data && response.data.responseTxt==="NoAuthorization"){
					childRefAuthorization.current.handleClickOpen();
				}
			}).catch((error) => {
				// console.log(error);
				setSeverityAlert("error");
				setAlertMessage(""+error);			
          		childRefAlert.current.handleClickOpen();	
				return false;
		  	})	
	}

	function saveData(){
		childRefSave.current.handleClickOpen();
	}

	function updatedList(obj) {
		setRow(obj);
	}

	
	return (
		<div> 
				<MetaTags>
            		<title>Visibility Setting</title>
          		</MetaTags>
				
				<Header hamburger={true} pageTitle="Visibility Setting" />
				{dataLoading?<LinearProgress />:null}

				<Box className='mainBox'>	


				    <Box ml={9} mr={9} mt={3} mb={20} >

						<div style={{textAlign:'center', marginBottom: 10}} >
							{(privileges && privileges.indexOf("update")>-1)?
								<div style={{marginTop: 25}}>
									<Button onClick={() => {saveData()}} size="small" color="default" variant="outlined" >Edit</Button>
								</div>
							:null}	
						</div>

	<TableContainer component={Paper}>
      <Table sx={{ width: '100%' }} aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell><b>Module</b></TableCell>            
            <TableCell align="center" ><b>Public</b></TableCell> 
            <TableCell align="center" ><b>Private</b></TableCell>      
          </TableRow>
        </TableHead>
        <TableBody>
          {(row)?<>
            <TableRow 
				sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
		  	>
				<TableCell component="th" scope="row">Accounts</TableCell>              
				<TableCell align="center" >{row.accounts===1?<RadioButtonCheckedIcon />:<RadioButtonUncheckedIcon />}</TableCell>
				<TableCell align="center" >{row.accounts===2?<RadioButtonCheckedIcon />:<RadioButtonUncheckedIcon />}</TableCell>              
		  	</TableRow>
            <TableRow 
              sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
            >
              <TableCell component="th" scope="row">Leads</TableCell>              
              <TableCell align="center" >{row.leads===1?<RadioButtonCheckedIcon />:<RadioButtonUncheckedIcon />}</TableCell>
              <TableCell align="center" >{row.leads===2?<RadioButtonCheckedIcon />:<RadioButtonUncheckedIcon />}</TableCell>              
            </TableRow>
            <TableRow 
				sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
		  	>
				<TableCell component="th" scope="row">Activities</TableCell>              
				<TableCell align="center" >{row.activities===1?<RadioButtonCheckedIcon />:<RadioButtonUncheckedIcon />}</TableCell>
				<TableCell align="center" >{row.activities===2?<RadioButtonCheckedIcon />:<RadioButtonUncheckedIcon />}</TableCell>              
		  	</TableRow>
		</>:null}
        </TableBody>
      </Table>
    </TableContainer>


					</Box>

				

				</Box>
				


				<Alert severityAlert={severityAlert} alertMessage={alertMessage} ref={childRefAlert} />	
				<VisibilitySave row={row} userObj={userObj} updatedList={updatedList} ref={childRefSave} />			
			
				<Authorization ref={childRefAuthorization} />			
		</div>	
	);
  }